import styled from "styled-components"
import BACKGROUNDS from "./constants"

export default styled.section`
  padding: ${({ padding = "5rem 0" }) => padding};
  ${({ background }) => background && BACKGROUNDS[background]}
  border-radius: ${({ borderRadius = "none" }) => borderRadius};
`
